export default `vec2 pmodg(vec2 p, float n){
    float a=mod(atan(p.y, p.x),TAUg/n)-.5 *TAUg/n;
    return length(p)*vec2(sin(a),cos(a));
  }

  float de( vec3 p ){
    for(int i=0;i<4;i++){
      p.xy = pmodg(p.xy,10.);  p.y-=2.;
      p.yz = pmodg(p.yz, 12.); p.z-=10.;
    }
    return dot(abs(p),normalize(vec3(13.0,1.0,7.0)))-.7;
  }`